type ConfigurationType = {
  types?: string
}

const onBefore = (monaco, configuration: ConfigurationType) => {
  monaco.languages.typescript.typescriptDefaults.setCompilerOptions({
    target: monaco.languages.typescript.ScriptTarget.ES2020,
    allowNonTsExtensions: true,
    moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs,
    module: monaco.languages.typescript.ModuleKind.ESNext,
  })

  monaco.languages.typescript.typescriptDefaults.addExtraLib(
    `
    ${configuration?.types ?? ''}
`,
    'file:///types.d.ts',
  )
}

const onAfter = (editor, monaco, configuration: ConfigurationType) => {
  monaco.editor.setTheme('vs-dark')

  monaco.languages.typescript.typescriptDefaults.addExtraLib(
    `
    ${configuration?.types ?? ''}
`,
    'file:///types.d.ts',
  )
}

export const CodeLanguageTypescript = {
  onBefore,
  onAfter,
}
